import { render, staticRenderFns } from "./main-product.vue?vue&type=template&id=a3f66830&scoped=true&"
import script from "./main-product.vue?vue&type=script&lang=js&"
export * from "./main-product.vue?vue&type=script&lang=js&"
import style0 from "./main-product.vue?vue&type=style&index=0&id=a3f66830&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f66830",
  null
  
)

export default component.exports